import React from "react";
import HeartbeatMonitor from "./HeartbeatMonitor";

function DistributeurCard({ d, onDelete, onClick }) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      onClick={() => onClick(d)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        border: `2px solid ${isHovered ? "#1e293b" : "#e5e7eb"}`,
        borderRadius: 16,
        padding: "1.5rem",
        minWidth: 280,
        maxWidth: 320,
        background: "#fff",
        cursor: "pointer",
        boxShadow: isHovered ? "0 8px 24px rgba(0,0,0,0.12)" : "0 2px 12px rgba(0,0,0,0.06)",
        transform: isHovered ? "translateY(-4px)" : "translateY(0)",
        transition: "all 0.2s ease",
        flex: "0 0 auto",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
        <div style={{ flex: 1 }}>
          <h3 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 700, color: "#1e293b" }}>
            {d.display_name || d.id}
          </h3>
          {d.display_name && d.display_name !== d.id && (
            <p style={{ margin: "2px 0 0", fontSize: "0.75rem", color: "#94a3b8" }}>
              ID: {d.id}
            </p>
          )}
          <div style={{ marginTop: "0.5rem" }}>
            <HeartbeatMonitor distributeurId={d.id} />
          </div>
        </div>
      </div>

      {/* Drinks */}
      <div style={{
        background: "#f8fafc",
        borderRadius: 12,
        padding: "1rem",
        marginBottom: "1rem"
      }}>
        <div style={{
          fontSize: "0.75rem",
          fontWeight: 600,
          color: "#64748b",
          marginBottom: "0.75rem",
          textTransform: "uppercase",
          letterSpacing: "0.5px"
        }}>
          Boissons
        </div>
        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "space-around" }}>
          {(d.drinks || []).length === 0 ? (
            <p style={{ color: "#94a3b8", fontSize: "0.85rem", margin: 0 }}>Aucune boisson</p>
          ) : (
            d.drinks.map((drink, i) => {
              const unlimited = drink.max_capacity <= 0;
              const pct = unlimited ? null : Math.round((drink.curr_capacity / drink.max_capacity) * 100);
              const barColor = unlimited ? "#94a3b8" : pct > 50 ? "#22c55e" : pct > 20 ? "#f59e0b" : "#ef4444";
              return (
                <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                  <div style={{
                    height: 72,
                    width: 20,
                    borderRadius: 10,
                    background: "#e2e8f0",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "flex-end",
                    marginBottom: 6,
                    border: "2px solid #fff",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.08)"
                  }}>
                    <div style={{
                      height: unlimited ? "100%" : `${pct}%`,
                      width: "100%",
                      background: barColor,
                      transition: "height 0.3s ease",
                      borderRadius: "0 0 8px 8px"
                    }} />
                  </div>
                  <span style={{
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    color: "#1e293b",
                    textAlign: "center",
                    lineHeight: 1.2,
                    marginBottom: 2
                  }}>
                    {drink.drink_name}
                  </span>
                  <span style={{
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    color: barColor,
                    padding: "2px 6px",
                    background: barColor + "20",
                    borderRadius: 6
                  }}>
                    {unlimited ? "∞" : `${pct}%`}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* Delete */}
      <DeleteButton onDelete={onDelete} distributeurId={d.id} />
    </div>
  );
}

function DeleteButton({ onDelete, distributeurId }) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      onClick={(e) => { e.stopPropagation(); onDelete(distributeurId); }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: isHovered ? "#ef4444" : "#fff",
        color: isHovered ? "#fff" : "#ef4444",
        padding: "0.5rem 1rem",
        border: `1px solid ${isHovered ? "#ef4444" : "#fecaca"}`,
        borderRadius: 8,
        cursor: "pointer",
        fontSize: "0.8rem",
        fontWeight: 600,
        width: "100%",
        transition: "all 0.2s ease",
      }}
    >
      🗑️ Supprimer
    </button>
  );
}

export default DistributeurCard;
